import React, { useEffect, useState } from 'react';
import useQuery from '../../app/common/util/hooks';
import { Avatar, Box, Button, Card, CardContent, CardHeader, Grid } from '@mui/material';
import agent from '../../app/api/agent';
import { toast } from 'react-toastify';
import { useStore } from '../../app/stores/store';
import EmailIcon from '@mui/icons-material/Email';
import LoginForm from './forms/Login';
import { withNavbar } from '../../app/layout/HOC';
import { router } from '../../app/router/Routes';

function EmailConfirmSuccess() {
    const { modalStore } = useStore();
    const email = useQuery().get('email') as string;
    const token = useQuery().get('token') as string;

    if (!email || !token) router.navigate('/');

    const Status = {
        Verifying: 'Verifying',
        Failed: 'Failed',
        Success: 'Success'
    }

    const [status, setStatus] = useState(Status.Verifying);

    function handleConfirmEmailResend() {
        agent.Account.resendEmailConfirm(email).then(() => {
            toast.success('Verification email resent - please check your email');
        }).catch(error => console.log(error));
    }

    useEffect(() => {
        agent.Account.verifyEmail(token, email).then(() => {
            setStatus(Status.Success)
        }).catch(() => {
            setStatus(Status.Failed)
        })
    }, [Status.Failed, Status.Success, token, email])

    function getBody() {
        switch (status) {
            case Status.Verifying:
                return <p>Verifying...</p>;
            case Status.Failed:
                return (
                    <Box component='div'>
                        <p>Verification failed.  You can try resending the verify link to your email</p>
                        <Button color='secondary' size='medium' onClick={handleConfirmEmailResend}>Resend email</Button>
                    </Box >
                );
            case Status.Success:
                return (
                    <div>
                        <p>Email has been verified - you can now login</p>
                        <Button color='primary' size='medium' onClick={() => modalStore.openModal(<LoginForm />)}>Login</Button>
                    </div>
                );
        }
    }
    return (
        <Grid container justifyContent="center" alignItems='center' sx={{ bgcolor: '#f8faff', height: 480, marginTop: 12, }}>
            <Grid item xs={8}>
                <Card sx={{ maxWidth: 400, height: '100%' }}>
                    <CardHeader
                        avatar={
                            <Avatar>
                                <EmailIcon />
                            </Avatar>
                        }
                        title={<strong>Email verification</strong>}
                    />
                    <CardContent>
                        {getBody()}
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    )
}

const EmailConfirmSuccessPage = withNavbar(EmailConfirmSuccess);

export default EmailConfirmSuccessPage;